import {page_json} from '../progress/feature.progress.svelte.js';
import {productsets} from './feature.productsets.svelte.js';
import {
  PRODUCTSET_TYPE_PRODUCTSET_TO_CHOOSE_1_N,
  PRODUCTSET_TYPE_SHOW_FIRST_BOOK_ALL
} from '../../AppConstants.js';

const aSupportedProductSetTypes = [
  PRODUCTSET_TYPE_PRODUCTSET_TO_CHOOSE_1_N,
  PRODUCTSET_TYPE_SHOW_FIRST_BOOK_ALL
];

export function importFromPageConfigAjaxCall()
{
  productsets.aProductIDsInPersistedSets = Array.isArray(page_json.data?.jsonHmkProductSetMemberIDs)
    ? page_json.data.jsonHmkProductSetMemberIDs
        .map((iProductID) => parseInt(iProductID, 10))
        .filter((iProductID) => iProductID > 0)
    : [];

  const aInput = page_json.data?.jsonHmkCatalogueProductSets;
  if ( !Array.isArray(aInput) )
  {
    productsets.aItems = [];
    return;
  }

  productsets.aItems = aInput
    .filter((oInputProductSet) => aSupportedProductSetTypes.includes(oInputProductSet.Type))
    .map((oInputProductSet) => ({
      iID: parseInt(oInputProductSet.ProductSetID, 10) || 0,
      sType: oInputProductSet.Type || '',
      sTitle: oInputProductSet.Title || '',
      iMainProductID: parseInt(oInputProductSet.MainProductExternalID, 10) || 0,
      aProductIDs: Array.isArray(oInputProductSet.ProductExternalIDs)
        ? oInputProductSet.ProductExternalIDs.map((iProductID) => parseInt(iProductID, 10)).filter((iProductID) => iProductID > 0)
        : [],
      iProductCategoryID: parseInt(oInputProductSet.ProductCategoryID, 10) || 0,
      iProductCategoryExternalID: parseInt(oInputProductSet.ProductCategoryExternalID, 10) || 0,
      iSortOrder: parseInt(oInputProductSet.SortOrder, 10) || 0,
      // Geen bIsHighlighted: "uitgelicht" is publieke-website-gedrag, niet iets in de webshop.
      bIsRecommended: oInputProductSet.IsRecommended === true || oInputProductSet.IsRecommended === 1 || oInputProductSet.IsRecommended === '1'
    }))
    .filter((oProductSet) => oProductSet.iID > 0 && oProductSet.iMainProductID > 0 && oProductSet.aProductIDs.length >= 2);
}
